import React from 'react';
import { Items } from 'containers/CahierJournal/DayColumn/Seance/CJEventBody/Items';
import { Material } from '@teetsh/app/src/types/event';
import { BOLabels } from '@teetsh/app/src/types/user';
import { CustomFieldRO } from 'containers/CahierJournal/DayColumn/Seance/CJEventBody/CustomFieldRO';
import { OldCustomField } from '@teetsh/app/src/types/oldCustomField';
import { useTranslation } from 'react-i18next';
import { useFieldsToDisplay } from 'containers/CahierJournal/Toolbar/Filters/FieldsToDisplay/atom';
import { BoFields } from 'types/bo';
import { CustomFieldDefinition } from 'types/customField';

interface Props {
  bo: BoFields;
  materials: Material[];
  customFieldDefinitions: CustomFieldDefinition[];
  customFields: OldCustomField[];
  boLabels: BOLabels;
  print: boolean;
  onChangeCustomField?: (customField: OldCustomField) => void;
}

export function Informations(props: Props) {
  const {
    bo: { matiere = [], domaine = [], competence = [], goals = [] },
    materials = [],
    boLabels,
    customFields,
    customFieldDefinitions,
    print,
  } = props;
  const fieldsToDisplay = useFieldsToDisplay();
  const { t } = useTranslation(['cahierJournal']);

  return (
    <>
      {fieldsToDisplay?.includes('Matieres') && (
        <Items
          items={matiere}
          pluralTitle={boLabels.matierePluralName}
          title={boLabels.matiereSingularName}
        />
      )}
      {fieldsToDisplay?.includes('Domaines') && (
        <Items
          items={domaine}
          pluralTitle={boLabels.domainePluralName}
          title={boLabels.domaineSingularName}
        />
      )}
      {fieldsToDisplay?.includes('Competences') && (
        <Items
          items={competence}
          pluralTitle={boLabels.competencePluralName}
          title={boLabels.competenceSingularName}
        />
      )}
      {fieldsToDisplay?.includes('Objectifs') && (
        <Items
          items={goals}
          pluralTitle={boLabels.objectifPluralName}
          title={boLabels.objectifSingularName}
        />
      )}
      {fieldsToDisplay?.includes('materials') && (
        <Items
          items={materials}
          pluralTitle={t('cahierJournal:seance.materials')}
          title={t('cahierJournal:seance.material')}
        />
      )}
      {(customFields || []).map(customField => (
        <CustomFieldRO
          onChange={c => props?.onChangeCustomField?.(c)}
          customFieldDefinition={customFieldDefinitions.find(
            def => def.id === customField.id,
          )}
          print={print}
          customField={customField}
          key={customField.id}
        />
      ))}
    </>
  );
}
